import { z } from "zod";

export const managedEventWizardSchema = z.object({
  name: z.string().min(1, "Name is required"),
  team_ids: z.array(z.string()).min(1, "Select at least one team"),
  category: z.string().min(1, "Category is required"),
  participant_scope: z.enum(["INDIVIDUAL", "JOINT"]),
  duration_minutes: z.number().nullable().optional(),
  round_robin_pool_active: z.boolean(),
  status: z.enum(["ACTIVE", "INACTIVE"]),
});

export type ManagedEventWizardData = z.infer<typeof managedEventWizardSchema>;
